import ivyStore from '@ivy/fts/ivyStore'
import showBindPhone from "@ivy/fts/showBindPhone"
import router from '../router'
import * as qs from 'qs'

export class Store {
  logined = ivyStore.logined
  async login(force = 0, disableOther = true) {
    if (router.currentRoute.query.pageFor === 'adminCheck') return 'adminCheck'
    return await ivyStore.login2(force, disableOther)
  }
  async bindPhone(options) {
    return await ivyStore.bindPhone(options)
  }
  async showBindPhone(redirectUrl?) {
    return await showBindPhone(redirectUrl)
  }
  async uploadPoint(params: any, url: string = '/api/stat/upload/h5') {
    let img = new Image(1, 1)
    img.onload = () => img = null
    const globalParams = ivyStore.globalParameter()
    const requestUrl = `${url}?${qs.stringify(Object.assign(globalParams, params), { arrayFormat: 'brackets' })}`
    img.src = requestUrl
  }
}

export default new Store()
